import React from 'react';

export default function PageOne(){
    return (
        <div className='home-text'>
            <h1 style={{color:'var(--text-white)', fontSize:'4rem', padding:'0 2rem'}}>Miguel Gil</h1>
            <h2 style={{fontSize:'1.3em'}} >Full<span className='symbol-green'>-</span>stack Developer</h2>
        </div>
    )
}